import React, { useState, useMemo, useCallback } from 'react';
import { galleryItems, galleryTabs } from '../mock/data';
import { useReveal } from '../hooks/useReveal';

export default function Gallery() {
  const [active, setActive] = useState('All');
  const { ref, inView } = useReveal();

  const filterItems = useCallback(
    (category) => (category === 'All' ? galleryItems : galleryItems.filter((g) => g.cat === category)),
    []
  );

  const items = useMemo(() => filterItems(active), [active, filterItems]);

  return (
    <section id="gallery" className="py-20 md:py-28 bg-white">
      <div className="container-x">
        <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} text-center max-w-2xl mx-auto`}>
          <span className="section-eyebrow">CAMPUS GALLERY</span>
          <h2 className="section-title mt-4 text-[34px] md:text-[44px] leading-tight">Life at PCA</h2>
          <p className="mt-4 text-slate-600">Take a visual tour of our campus, labs, classrooms, and student life.</p>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-2">
          {galleryTabs.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(t)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                active === t
                  ? 'bg-[#0B2E6E] text-white shadow-[0_10px_24px_-12px_rgba(11,46,110,0.55)]'
                  : 'bg-[var(--pca-blue-tint)] text-slate-600 hover:bg-blue-100'
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((g) => (
            <div key={g.src} className="gallery-item lift bg-slate-100 relative">
              <img src={g.src} alt={g.label} loading="lazy" className="w-full h-64 object-cover" />
              <div className="overlay" />
              <div className="absolute bottom-4 left-4 right-4 text-white z-10">
                <div className="inline-block px-3 py-1 rounded-full text-[11px] font-semibold bg-white/20 backdrop-blur border border-white/30">{g.cat}</div>
                <div className="mt-1 font-bold text-lg drop-shadow">{g.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
